import { Container } from '@/components/container';
import { ErrorRoot } from '@/components/errors';
import { ThemedToast } from '@/components/toast';
import { auth } from '@/lib';
import { router } from '@/router';
import { NosIdApp } from '@nosinovacao/nosid-mfe-common';
import { createRootRoute, Outlet, useRouter } from '@tanstack/react-router';
import * as React from 'react';

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFound,
  errorComponent: ErrorRoot,
});

function RootComponent() {
  return (
    <ThemedToast>
      <NosIdApp
        router={router}
        eventType="onResolved"
        beforeMount={async ({ to }) => {
          if (to.anonymous) return true;

          const isLoggedIn = await auth.isLoggedIn();
          if (!isLoggedIn) {
            await auth.login();
            return false;
          }
          return true;
        }}
      >
        <Container>
          <Outlet />
        </Container>
      </NosIdApp>
    </ThemedToast>
  );
}

function NotFound() {
  const { navigate } = useRouter();
  React.useEffect(() => {
    navigate({
      to: '/home',
      search: {} as never,
    });
  }, [navigate]);
  return <></>;
}
